/**
 * Off-screen but ANNOUNCED — text a screen reader reads and a sighted reader never sees.
 *
 * Clipped to a 1px box rather than `display: none` or `visibility: hidden`, both of which remove
 * the text from the accessibility tree entirely, which would defeat the point. Inlined rather
 * than importing `@mui/utils`, which is not a direct dependency of this app — a transitive one
 * resolves in a dev build and is not a dependency anybody declared.
 *
 * ⚠️ **EVERY LENGTH IS A STRING, and the two that were not caused a real defect.** MUI's `sx`
 * reads a bare `width: 1` as the FRACTIONAL shorthand for 100%, so the span becomes a full-width
 * absolutely-positioned element that escapes its container and makes the whole page scroll
 * sideways on a phone — the one thing the layout rules forbid. It is invisible, so nothing looks
 * wrong; the fixed copy records being found by measuring the widest element on the page.
 *
 * ⚠️ **THIS FILE EXISTS BECAUSE THE FIX REACHED ONE COPY OF TWO.** `ProvenanceStrip` corrected
 * the bare numbers and wrote down why; `Can` — used on twenty call sites across the product —
 * still carried `width: 1, height: 1` months later, because they were separate declarations and
 * a fix in one has no way to reach the other. That is the shape this codebase keeps paying for:
 * two copies of one rule, where only one of them learns. Adding a THIRD for the menu badges is
 * what made extracting it cheaper than repeating it.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
  padding: 0,
  margin: '-1px',
} as const;
